import Parse from "parse";
import {Languages} from "../utilities/Constants";

class Video extends Parse.Object {

    constructor() {
        super('Video');
    }

    getTitle() {
        return this.get('title');
    }

    setTitle(title) {
        this.set('title', title)
    }

    getTagline() {
        return this.get('tagline');
    }

    setTagline(tagline) {
        this.set('tagline', tagline)
    }

    getBody() {
        return this.get('body');
    }

    setBody(body) {
        this.set('body', body)
    }

    getVideoURL() {
        return this.get('videoUrl');
    }

    setVideoURL(videoURL) {
        this.set('videoUrl', videoURL)
    }

    getImageUrl() {
        return this.get("coverPhoto").url()
    }

    setCoverPhotoFile(file) {
        this.set("coverPhoto", file);
    }

    setEnabled(enabled) {
        this.set('enabled', enabled);
    }

    getCategoryTitle() {
        return this.get("category").getTitle();
    }

    getCategory() {
        return this.get("category");
    }

    setCategory(category) {
        this.set('category', category);
        this.set('categoryId', category.id);
    }

    getLanguage() {
        const languageCode = this.get('languageCodeString');
        return Languages.filter(option => option.key === languageCode)[0]
    }

    setLanguageCode(code) {
        this.set('languageCodeString', code);
    }

    static getQuery() {
        const parseQuery = new Parse.Query(Video);
        parseQuery.equalTo("enabled", true);
        parseQuery.ascending("title");
        parseQuery.include("category");
        return parseQuery;
    }

    static getFilteredQuery(languageCode, categoryId, skip, limit) {
        const parseQuery = new Parse.Query(Video);
        parseQuery.equalTo("enabled", true);
        parseQuery.include("category");
        parseQuery.skip(skip);
        parseQuery.limit(limit);
        parseQuery.ascending("title")
        parseQuery.withCount()
        if (languageCode != null) {
            parseQuery.equalTo("languageCodeString", languageCode);
        }
        if (categoryId != null) {
            parseQuery.equalTo("categoryId", categoryId);
        }
        return parseQuery;
    }
}

export default Video;